/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import Button from 'components/Button';
import { Form, Formik } from 'formik';
import i18n from 'i18n';
import { authenticateRequest } from 'modules/authenticate/actions';
import { AuthenticateFields } from 'modules/authenticate/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import useWindowDimensions from 'hooks/useWindowWidth';
import validationSchema from './schema';
import styles from './styles';
import screenFields from './userLoginFormFields';

const useStyles = makeStyles(styles);

const initialValues: AuthenticateFields = {
  email: '',
  password: '',
  mfa_required: true,
  recaptcha_token: '',
};

interface Props {
  authenticateRequest: (a: typeof initialValues) => void;
  isLoading: boolean;
  language?: string;
}

const UserLoginForm: React.FC<Props> = ({ authenticateRequest, isLoading }) => {
  const classes = useStyles();

  const onSubmit = values => {
    // eslint-disable-next-line no-undef
    grecaptcha
      .execute(process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!, {
        action: 'autosky_admin_operator_login',
      })
      .then(token => {
        authenticateRequest({ ...values, 'recaptcha_token': token });
      });
  };

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.recaptcha.net/recaptcha/api.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${process
      .env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!}`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const { width } = useWindowDimensions();

  return (
    <Grid container item xs={12} alignContent="flex-start">
      {width > 960 && (
        <Grid item container xs={12} className={classes.spacingContainer}>
          <Grid item xs={12} className={classes.login}>
            <Typography variant="h3" className={classes.text}>
              <b>{i18n.t('ADMIN_PANEL_KEY')}</b> Autosky
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.subtitleLogin}>
              {i18n.t('LOGIN_PAGE.SUBTITLE_KEY')}
            </Typography>
          </Grid>
        </Grid>
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, errors, values }) => (
          <Form>
            <Grid container justify="center">
              <Grid
                item
                container
                xs={12}
                spacing={2}
                className={classes.loginGrid}
                justify="center"
              >
                <GenericForm
                  values={values}
                  screenFields={applyI18n(screenFields, i18n.language)}
                  setFieldValue={setFieldValue}
                  errors={errors}
                />
              </Grid>
              <Grid
                container
                justify="flex-end"
                item
                xs={12}
                className={classes.forgotPasswordContainer}
              >
                <Grid item className={classes.forgotPasswordLinkContainer}>
                  <Typography
                    id="forgot-link"
                    variant="button"
                    component={Link}
                    to="/forgotPassword"
                    className={classes.forgotPasswordLinkText}
                  >
                    {i18n.t('FORGOT_PASSWORD_KEY')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} className={classes.spacingContainer}>
                <Button
                  id="submit-button"
                  size="large"
                  className={classes.loginButton}
                  type="submit"
                  isLoading={isLoading}
                  fullWidth
                >
                  {i18n.t('LOGIN_KEY')}
                </Button>
                <div
                  className="g-recaptcha"
                  data-sitekey={
                    process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!
                  }
                  data-callback="onSubmit"
                  data-size="invisible"
                  data-badge="bottomright"
                ></div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({ authenticate }) => ({
  isLoading: authenticate.isLoading,
});

export default connect(mapStateToProps, {
  authenticateRequest,
})(UserLoginForm);
